import { render, staticRenderFns } from "./FormsKeywordSearch.vue?vue&type=template&id=7253dfc4&scoped=true&"
import script from "./FormsKeywordSearch.vue?vue&type=script&lang=js&"
export * from "./FormsKeywordSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7253dfc4",
  null
  
)

export default component.exports